<template>
  <div
    :id="id"
    class="post"
  >
    <h2 class="font-title text-2xl lg:text-3xl font-bold text-ocean-900">
      {{ title }}
    </h2>
    <div
      v-if="titleDescription"
      class="vetster-prose font-normal leading-7 text-neutral-700 mt-1.5"
    >
      {{ titleDescription }}
    </div>
    <hr class="border-ocean-200 mt-4" />
  </div>
</template>

<script>
import { slugCase } from '@/helpers/format';

export default {
  name: 'VetsterPostNavHeader',

  props: {
    navTitle: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleDescription: {
      type: String,
      default: null,
    },
    appendId: {
      type: String,
      default: '',
    },
  },

  computed: {
    id() {
      return slugCase(`${this.navTitle}${this.appendId}`);
    },
  },
};
</script>
